"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = _interopRequireDefault(require("./util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * helper function to validate a response from a services
 * @param response - the response to validate
 * @param service - the service we are attempting to contact
 */
var validateResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response, service) {
    var responseText, errorMessage, responseJson;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status === 200)) {
              _context.next = 11;
              break;
            }

            _context.next = 3;
            return response.text();

          case 3:
            responseText = _context.sent;
            _context.prev = 4;
            return _context.abrupt("return", JSON.parse(responseText));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](4);

          case 10:
            return _context.abrupt("return", responseText);

          case 11:
            if (!(response.status === 401)) {
              _context.next = 15;
              break;
            }

            throw new Error('Unauthorised Access !!');

          case 15:
            if (!(response.status === 500)) {
              _context.next = 19;
              break;
            }

            throw new Error("".concat(service, " service unavailable"));

          case 19:
            errorMessage = 'Error';
            _context.next = 22;
            return response.json();

          case 22:
            responseJson = _context.sent;

            if (responseJson !== null && responseJson !== undefined && responseJson.ErrorResponse !== undefined) {
              errorMessage = responseJson.ErrorResponse.error;
            } else if (responseJson && responseJson.errorString && responseJson.errorCode) {
              errorMessage = "Error Code ".concat(responseJson.errorCode, ": ").concat(responseJson.errorString);
            } else if (responseJson && responseJson.response && responseJson.response.error) {
              errorMessage = responseJson.response.error;
            } else if (responseJson && responseJson.response && responseJson.response.errorString) {
              errorMessage = responseJson.response.errorString;
            }

            throw new Error(errorMessage);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 8]]);
  }));

  return function validateResponse(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var keystoneLogin = function keystoneLogin(loginUserForm) {
  var endpoint = "/user/auth/".concat(_util["default"].getUserAPIVersion(), "/getToken");
  return fetch(endpoint, {
    method: 'post',
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json',
      // this header value is used as the host for the reset link sent in the email
      'origin-ui': _util["default"].getHostname()
    },
    body: JSON.stringify(loginUserForm)
  }).then( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", validateResponse(response, 'User'));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }())["catch"](function (err) {
    console.error(err);
    throw err;
  });
};

var cookieLogin = function cookieLogin() {
  var endpoint = "/user/auth/".concat(_util["default"].getUserAPIVersion(), "/refreshToken");
  return fetch(endpoint, {
    method: 'get',
    headers: {
      Accept: 'application/json'
    }
  }).then(function (response) {
    return validateResponse(response, 'User');
  })["catch"](function (err) {
    console.error(err);
    throw err;
  });
}; // EVS2-633 : JWT Token Logout implementation


var keystoneLogout = function keystoneLogout(user, callback) {
  var endpoint = "/user/auth/".concat(_util["default"].getUserAPIVersion(), "/endSession");
  fetch(endpoint, {
    method: 'get',
    headers: {
      Authorization: "Bearer ".concat(user.idToken)
    }
  }).then( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              callback(response);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }())["catch"](function (err) {
    callback(err);
  });
};

var updatePassword = function updatePassword(idToken, loginUserForm) {
  return fetch("".concat(_util["default"].getAPIGatewayURL(), "/user/admin/").concat(_util["default"].getUserAPIVersion(), "/updatePassword"), {
    method: 'post',
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json',
      Authorization: "Bearer ".concat(idToken)
    },
    body: JSON.stringify(loginUserForm)
  }).then( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(response) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", validateResponse(response, 'User'));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }());
};

var logout = function logout(user, callback) {
  var sentienceConfig = _util["default"].getConfig();

  var logoutUrl = "".concat(_util["default"].getAPIGatewayURL(), "/openam/oauth2") + "/".concat(sentienceConfig.realm, "/connect/endSession") + "?id_token_hint=".concat(user.idToken) + "&post_logout_redirect_uri=".concat(_util["default"].getRedirectURI(), "/login");
  fetch(logoutUrl, {
    method: 'get',
    headers: {
      Authorization: "Bearer ".concat(user.idToken)
    }
  }).then( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              callback(response);

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }())["catch"](function (err) {
    callback(err);
  });
};

var getUserData = function getUserData(user) {
  return fetch("".concat(_util["default"].getAPIGatewayURL(), "/user/admin/").concat(_util["default"].getUserAPIVersion(), "/user"), {
    method: 'get',
    headers: {
      Authorization: "Bearer ".concat(user.idToken),
      loggedUser: user.email
    }
  }).then( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(response) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", validateResponse(response, 'User'));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }())["catch"](function (err) {
    console.error(err);
    throw err;
  });
};

var updateUserPreferences = function updateUserPreferences(idToken, prefs) {
  return fetch("".concat(_util["default"].getAPIGatewayURL(), "/user/admin/").concat(_util["default"].getUserAPIVersion(), "/update-user-preferences"), {
    method: 'post',
    headers: {
      'content-type': 'application/json',
      Authorization: "Bearer ".concat(idToken)
    },
    body: JSON.stringify(prefs)
  });
};

var _default = {
  validateResponse: validateResponse,
  keystoneLogin: keystoneLogin,
  cookieLogin: cookieLogin,
  keystoneLogout: keystoneLogout,
  updatePassword: updatePassword,
  logout: logout,
  getUserData: getUserData,
  updateUserPreferences: updateUserPreferences
};
exports["default"] = _default;